import { useState, useEffect } from 'react';
import ToggleForm from '../../../components/toggle/ToggleForm';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const defaultProps = {
  profile: {},
  onChangeCallback: () => {},
};

const ShowScores = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, onChangeCallback } = mergedProps;
  const [toggle, setToggle] = useState(profile.scores);
  const showScores = profile.scores;
  // When mounting and changing a profile.
  useEffect(() => {
    setToggle(showScores);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id]);

  const handleShowScoreOnchange = (field, newValue) => {
    if (newValue === null) return;
    setToggle(newValue);
    onChangeCallback(newValue);
  };

  return (
    <ToggleForm value={toggle} handleOnChange={handleShowScoreOnchange} />
  );
};

export default ShowScores;
